/** Tiempo máximo de una solicitud inmediata (NEW) en segundos. Editable en settings.requestTimeoutSec. */
export const REQUEST_TIMEOUT_DEFAULT_SEC = 90;
export const REQUEST_TIMEOUT_MIN_SEC = 30;
export const REQUEST_TIMEOUT_MAX_SEC = 600;

export const resolveRequestTimeoutSec = (settings = {}) => {
  const n = Number(settings.requestTimeoutSec);
  if (Number.isInteger(n) && n >= REQUEST_TIMEOUT_MIN_SEC && n <= REQUEST_TIMEOUT_MAX_SEC) return n;
  return REQUEST_TIMEOUT_DEFAULT_SEC;
};

/** Fecha de vencimiento de la solicitud (ms). Book later no usa este tope corto. */
export const resolveRequestExpiresAt = (booking, settings = {}, now = Date.now()) => {
  if (!booking || booking.bookLater) return null;
  const stored = Number(booking.requestExpiresAt);
  if (stored > 0) return stored;
  const start = Number(booking.bookingDate) || Number(booking.tripdate) || now;
  return start + resolveRequestTimeoutSec(settings) * 1000;
};

export const formatCountdown = (remainingMs) => {
  const total = Math.max(0, Math.ceil(remainingMs / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};
